/* istanbul ignore file */
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { Flex, Box } from '..';
var SlideWrapper = styled(Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var ScrollFlex = styled(Flex)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  overflow: auto;\n  & > ", " {\n    flex-shrink: 0;\n  }\n"], ["\n  position: relative;\n  overflow: auto;\n  & > ", " {\n    flex-shrink: 0;\n  }\n"])), SlideWrapper);
export { ScrollFlex, SlideWrapper };
var templateObject_1, templateObject_2;
//# sourceMappingURL=styles.js.map